import { Box, Divider, Modal, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import {
  CustomButton,
  FormModalTitle,
} from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import { RootState } from "../../../store/state";
import BaraGrouilleurTable from "./BaraGrouilleurTable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 600, md: 850, lg: 850 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  height: "80vh",
  overflow: "hidden"
};

interface Props {
  open: boolean;
  onClose(): void;
}

function BaraGrouilleurModal({ open, onClose }: Props) {
  const grouilleurs = useSelector((state: RootState) =>
  Object.values(state.grouilleur)
);

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t("rechercher_grouilleur")}
            onClose={handleClose}
            style={{padding: 3, marginBottom: 0}}
          />
        <Box sx={{overflow: "auto", height: "100%", p: 3, pb: 15}}>
          <Stack direction={"row"} justifyContent="space-between" spacing={2} alignItems="flex-end" mb={2}>
            <SigninTextInput
              title={""}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
            <SigninTextInput
              title={""}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
            <SigninTextInput
              title={"Localisation"}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
          </Stack>
          <Stack direction={"row"} justifyContent="space-between" spacing={2} alignItems="flex-end" mb={2}>
            <SigninTextInput
              title={"Nom et prénom"}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
            <SigninTextInput
              title={"Matricule"}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
            <SigninTextInput
              title={"Contact"}
              onChange={function (value: string): void {
                throw new Error("Function not implemented.");
              }}
              size="small"
              rootStyle={{marginTop: 0}}
            />
          </Stack>

          <Stack alignItems={"center"}>
          <CustomButton title={i18n.t("appliquer_recherche")} rootStyle={{width: 250}} />
          </Stack>
          <Divider sx={{my: 3}} />

         
          <BaraGrouilleurTable data={grouilleurs} />
          </Box>
        </Box>
      </form>
    </Modal>
  );
}

export default BaraGrouilleurModal;
